module.exports = __webpack_public_path__ + "img/boite-a-outils@2x-100.1701d0f1.jpg";